import React, { Fragment, useContext, useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  Paper,
  Grid,
  Avatar,
  Divider,
  Link,
  Typography,
} from "@material-ui/core";

// Contexts
import OrderContext from "../../../../context/orders/v1/OrdersContext";

const useStyles = makeStyles((theme) => ({
  paper: {
    marginBottom: theme.spacing(2),
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    fontSize: "0.9rem",
  },
  title: {
    color: theme.palette.text.primary,
    fontWeight: "bold",
    marginBottom: "0.1rem",
  },
  avatar: {
    width: theme.spacing(4),
    height: theme.spacing(4),
  },
  divider: {
    margin: "1rem 0",
  },
}));

const OrderEditCustomerInfo = () => {
  const classes = useStyles();
  const { order, setModal } = useContext(OrderContext);
  const [sameAdd, setSameAdd] = useState();

  useEffect(() => {
    if (order && order.shipping_address && order.billing_address) {
      let same = true;

      if (
        order.shipping_address.first_name !==
          order.billing_address.first_name ||
        order.shipping_address.last_name !== order.billing_address.last_name ||
        order.shipping_address.address1 !== order.billing_address.address1 ||
        order.shipping_address.address2 !== order.billing_address.address2 ||
        order.shipping_address.city !== order.billing_address.city ||
        order.shipping_address.province_code !==
          order.billing_address.province_code ||
        order.shipping_address.zip !== order.billing_address.zip ||
        order.shipping_address.country !== order.billing_address.country ||
        order.shipping_address.phone !== order.billing_address.phone
      ) {
        same = false;
      }

      setSameAdd(same);
    } else {
      setSameAdd(false);
    }
  }, [order]);

  return (
    <Grid container direction="column">
      <Paper className={classes.paper}>
        <Grid
          container
          spacing={1}
          direction="column"
          alignitem="flex-start"
          justifyContent="flex-start"
        >
          {/* Customer */}{" "}
          <Grid item container justifyContent="space-between">
            <Grid item>
              <Typography variant="body1" className={classes.title}>
                Customer{" "}
              </Typography>{" "}
            </Grid>{" "}
            <Grid item>
              <Avatar className={classes.avatar} />{" "}
            </Grid>{" "}
          </Grid>{" "}
          <Grid item container justifyContent="flex-start">
            <Typography variant="inherit" align="left">
              {" "}
              {order.customer &&
              order.customer.first_name &&
              order.customer.last_name
                ? `${order.customer.first_name} ${order.customer.last_name}`
                : "No customer"}{" "}
            </Typography>{" "}
          </Grid>
          <Divider className={classes.divider} orientation="horizontal" />
          {/* Contact Information */}{" "}
          <Grid item container justifyContent="space-between">
            <Grid item>
              <span
                style={{
                  textTransform: "uppercase",
                  fontSize: "0.8rem",
                }}
                className={classes.title}
              >
                Contact Information{" "}
              </span>{" "}
            </Grid>{" "}
            <Grid item>
              <Link
                component="button"
                onClick={() => setModal(true, "contact_info")}
              >
                Edit{" "}
              </Link>{" "}
            </Grid>{" "}
          </Grid>{" "}
          <Grid
            item
            container
            direction="column"
            alignitem="flex-start"
            justifyContent="flex-start"
          >
            <Typography variant="inherit" align="left">
              {" "}
              {!order.email ? (
                <Grid item> No contact information </Grid>
              ) : (
                <Fragment>
                  <Grid item>
                    {" "}
                    {order.email ? order.email : "No email address"}{" "}
                  </Grid>{" "}
                  {/* <Grid item>
                                        {order.phone ? order.phone : "No phone number"}
                                      </Grid> */}{" "}
                </Fragment>
              )}{" "}
            </Typography>{" "}
          </Grid>
          <Divider className={classes.divider} orientation="horizontal" />
          {/* Shipping Address */}{" "}
          <Grid item container justifyContent="space-between">
            <Grid item>
              <span
                style={{
                  textTransform: "uppercase",
                  fontSize: "0.8rem",
                }}
                className={classes.title}
              >
                Shipping Address{" "}
              </span>{" "}
            </Grid>{" "}
            <Grid item>
              <Link
                component="button"
                onClick={() => setModal(true, "shipping_info")}
              >
                Edit{" "}
              </Link>{" "}
            </Grid>{" "}
          </Grid>{" "}
          <Grid
            item
            container
            direction="column"
            alignitem="flex-start"
            justifyContent="flex-start"
          >
            <Typography variant="inherit" align="left">
              {" "}
              {order.shipping_address ? (
                <Fragment>
                  <Grid item>
                    {" "}
                    {order.shipping_address.first_name}{" "}
                    {order.shipping_address.last_name}{" "}
                  </Grid>{" "}
                  <Grid item> {order.shipping_address.address1} </Grid>{" "}
                  <Grid item> {order.shipping_address.address2} </Grid>{" "}
                  <Grid item>
                    {" "}
                    {order.shipping_address.city}{" "}
                    {order.shipping_address.province_code}{" "}
                    {order.shipping_address.zip}{" "}
                  </Grid>{" "}
                  <Grid item> {order.shipping_address.country} </Grid>{" "}
                  <Grid item> {order.shipping_address.phone} </Grid>{" "}
                </Fragment>
              ) : (
                <Grid item> No shipping address </Grid>
              )}{" "}
            </Typography>{" "}
          </Grid>
          <Divider className={classes.divider} orientation="horizontal" />
          {/* Billing Address */}{" "}
          <Grid item container justifyContent="space-between">
            <span
              style={{
                textTransform: "uppercase",
                fontSize: "0.8rem",
              }}
              className={classes.title}
            >
              Billing Address{" "}
            </span>{" "}
          </Grid>{" "}
          <Grid
            item
            container
            direction="column"
            alignitem="flex-start"
            justifyContent="flex-start"
          >
            <Typography variant="inherit" align="left">
              {" "}
              {sameAdd ? (
                <Grid
                  item
                  style={{
                    color: "grey",
                  }}
                >
                  Same as shipping address{" "}
                </Grid>
              ) : order.billing_address ? (
                <Fragment>
                  <Grid item>
                    {" "}
                    {order.billing_address.first_name}{" "}
                    {order.billing_address.last_name}{" "}
                  </Grid>{" "}
                  <Grid item> {order.billing_address.address1} </Grid>{" "}
                  <Grid item> {order.billing_address.address2} </Grid>{" "}
                  <Grid item>
                    {" "}
                    {order.billing_address.city}{" "}
                    {order.billing_address.province_code}{" "}
                    {order.billing_address.zip}{" "}
                  </Grid>{" "}
                  <Grid item> {order.billing_address.country} </Grid>{" "}
                  <Grid item> {order.billing_address.phone} </Grid>{" "}
                </Fragment>
              ) : (
                <Grid item> No billing address </Grid>
              )}{" "}
            </Typography>{" "}
          </Grid>{" "}
        </Grid>{" "}
      </Paper>{" "}
    </Grid>
  );
};

export default OrderEditCustomerInfo;
